import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';

/* 
 * Extend this to any non-strutural components
 * Adds loading and security handling
 */
export class BaseComponent extends LitElement {
	
	static get properties() {
		return {
			permission: {type: String},
			loading: {type: Boolean},
			loadingText: {type: String}
		};
	}

	constructor() {
		super();
		this.permission = null;	
		this.loading = false;
		this.loadingText = 'Loading...';
	}

	render() {		
		return html`
			<style>
				.load-mask {
					width: 100%;
					background-color: rgb(0, 0, 0, .5);
					position: relative;
					top: 0;
					left: 0;
				}
			</style>
					
			${this.loading ?
				html`<div class="load-mask">${this.loadingText}</div>`:
				html``		
			}							
		`;
	}	

};

